// One place for the transaction document checklists (buyer and seller stay consistent).
// Files are stored as deal documents (src/services/dealDocuments.js) with a `category` = the doc key.
export const DOC_TYPES = [
  { key: 'listingAgreement', label: 'Listing Agreement', required: false, task: /listing agreement/i },
  { key: 'bba', label: 'Buyer Broker Agreement', required: true, task: /(buyer broker agreement|\bbba\b)/i },
  { key: 'aba', label: 'ABA (Affiliated Business Arrangement disclosure)', required: true, task: /(\baba\b|affiliated business)/i },
  { key: 'wireFraud', label: 'Wire Fraud disclosure', required: true, task: /wire fraud (disclosure|advisory|form)/i },
  { key: 'flood', label: 'Flood Disclosure', required: true, task: /flood disclosure/i },
  { key: 'compensation', label: 'Compensation Agreement', required: true, task: /compensation agreement/i },
  { key: 'supplements', label: 'Additional Supplements / Riders / Addendums', required: false, multiple: true },
];
const pick = (keys) => keys.map((k) => DOC_TYPES.find((d) => d.key === k));
const UC_KEYS = ['aba', 'wireFraud', 'flood', 'compensation', 'supplements'];
export const BUYER_DOCS = pick(['bba', ...UC_KEYS]);        // buyer under contract
export const SELLER_UC_DOCS = pick(UC_KEYS);                  // seller under contract (no BBA)
export const SELLER_LISTING_DOCS = pick(['listingAgreement']); // new listing: optional for now
export const docsFor = (type, stage = 'underContract') => {
  if (/seller/i.test(type || '')) return stage === 'listing' ? SELLER_LISTING_DOCS : SELLER_UC_DOCS;
  if (/buyer/i.test(type || '')) return BUYER_DOCS;
  return [];
};
export const DOC_ACCEPT = '.pdf,.doc,.docx,.jpg,.jpeg,.png';
export const DOC_MAX_BYTES = 25 * 1024 * 1024; // matches storage.rules for deals/

// pending: { [key]: File[] }, existing: deal documents already saved (with category).
export function missingDocs(list, pending = {}, existing = []) {
  return list.filter((d) => d.required
    && !(pending[d.key] && pending[d.key].length)
    && !existing.some((e) => e.category === d.key));
}

export function missingDocsMessage(missing) {
  if (!missing.length) return '';
  const names = missing.map((d) => d.label.replace(/ \(.*\)$/, ''));
  const list = names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
  return `Please attach the ${list} before saving. ${missing.length === 1 ? 'It is' : 'They are'} required once the deal is under contract.`;
}

// Open "upload/collect" style tasks that match a doc that is now on file.
export function tasksToComplete(tasks = {}, categories = []) {
  const docs = DOC_TYPES.filter((d) => d.task && categories.includes(d.key));
  return Object.entries(tasks).filter(([, t]) => t && t.status !== 'completed'
    && /(upload|collect|receive|obtain|attach)/i.test(t.name || '')
    && docs.some((d) => d.task.test(t.name || ''))).map(([id]) => id);
}
